import React from 'react';
import PropTypes from 'prop-types';
import { CommonView } from 'widget/event_components/Ticket/components/Datetime/views/common';
import { CalendarView } from 'widget/event_components/Ticket/components/Datetime/views/calendar';

const DatetimeCheckoutController = ({
  event,
  variant,
  occurrences,
  setEvent,
  setTickets,
  settings,
  setOccurrencesDate,
  occurrenceDate,
  onClickBack,
}) => {
  if (variant === 'calendar')
    return <CalendarView event={event} occurrences={occurrences} settings={settings} setOccurrencesDate={setOccurrencesDate} />;
  return (
    <CommonView
      setEvent={setEvent}
      event={event}
      setTickets={setTickets}
      occurrences={occurrences}
      settings={settings}
      occurrenceDate={occurrenceDate}
      setOccurrencesDate={setOccurrencesDate}
      onClickBack={onClickBack}
    />
  );
};

DatetimeCheckoutController.propTypes = {
  variant: PropTypes.oneOf(['calendar', 'common']).isRequired,
};

export default DatetimeCheckoutController;
